(function() {
  'use strict';

  /**
   * PLP Badge Update Script — active-swatch priority
   *
   * Each product-card renders exactly one badge based only on its own active
   * .card-color-swatch--inner element. This keeps repeated products in a
   * combined listing independent: each card can display a different badge.
   *
   * Active-swatch priority:
   *   1. Preorder (rendered by the theme)
   *   2. Sold out
   *   3. X LEFT
   *   4. Other custom text (for example, BEST SELLER)
   *   5. New
   *   6. -XX% sale discount
   *   7. No badge
   *
   * IMPORTANT: card-color-swatch.liquid must output data-color-badge="New"
   * for a New sale item. The JavaScript cannot infer a New product tag when
   * Liquid outputs only a percentage value such as "-20%".
   */

  var PREORDER_BADGES = ['preorder', 'pre-order'];
  var SALE_BADGE_SELECTOR = '.sale-badge.badge';
  var started = false;

  function start() {
    if (started) return;
    started = true;

    function normalizeBadge(text) {
      return (text || '').trim();
    }

    function isPreorderBadge(text) {
      var lower = normalizeBadge(text).toLowerCase();

      for (var i = 0; i < PREORDER_BADGES.length; i++) {
        if (lower === PREORDER_BADGES[i]) return true;
      }

      return false;
    }

    function isSoldOutBadge(text) {
      var lower = normalizeBadge(text).toLowerCase();
      return lower === 'sold-out' || lower === 'sold out';
    }

    function isLowStockBadge(text) {
      return /^\d+\s+left$/i.test(normalizeBadge(text));
    }

    function isNewBadge(text) {
      return /^new$/i.test(normalizeBadge(text));
    }

    function isSaleBadge(text) {
      return /^-\d+%$/.test(normalizeBadge(text));
    }

    function hideBadgeType(wrapper, selector) {
      wrapper.querySelectorAll(selector).forEach(function(badge) {
        badge.style.display = 'none';
      });
    }

    function showBadgeType(wrapper, selector) {
      wrapper.querySelectorAll(selector).forEach(function(badge) {
        badge.style.display = '';
      });
    }

    function showSoldOutBadge(wrapper) {
      hideBadgeType(wrapper, '.custom-badge.badge');
      hideBadgeType(wrapper, SALE_BADGE_SELECTOR);

      var soldOutBadge = wrapper.querySelector('.sold-out-badge.badge');
      if (soldOutBadge) {
        soldOutBadge.style.display = '';
        return;
      }

      soldOutBadge = document.createElement('div');
      soldOutBadge.className = 'sold-out-badge badge';
      soldOutBadge.setAttribute('data-injected-badge', 'true');
      soldOutBadge.textContent = 'Sold out';
      wrapper.insertBefore(soldOutBadge, wrapper.firstChild);
    }

    function showTextBadge(wrapper, text) {
      hideBadgeType(wrapper, '.sold-out-badge.badge');
      hideBadgeType(wrapper, SALE_BADGE_SELECTOR);

      var customBadge = wrapper.querySelector('.custom-badge.badge');
      if (customBadge) {
        customBadge.textContent = text;
        customBadge.style.display = '';
        return;
      }

      customBadge = document.createElement('div');
      customBadge.className = 'custom-badge badge';
      customBadge.setAttribute('data-injected-badge', 'true');
      customBadge.textContent = text;
      wrapper.insertBefore(customBadge, wrapper.firstChild);
    }

    function showSaleBadge(wrapper, text) {
      hideBadgeType(wrapper, '.custom-badge.badge');
      hideBadgeType(wrapper, '.sold-out-badge.badge');

      var saleBadge = wrapper.querySelector(SALE_BADGE_SELECTOR);
      if (saleBadge) {
        saleBadge.textContent = text;
        saleBadge.style.display = '';
        return;
      }

      saleBadge = document.createElement('div');
      saleBadge.className = 'sale-badge badge';
      saleBadge.setAttribute('data-injected-badge', 'true');
      saleBadge.textContent = text;
      wrapper.insertBefore(saleBadge, wrapper.firstChild);
    }

    function hideAllBadges(wrapper) {
      hideBadgeType(wrapper, '.custom-badge.badge');
      hideBadgeType(wrapper, '.sold-out-badge.badge');
      hideBadgeType(wrapper, SALE_BADGE_SELECTOR);
    }

    function setBadge(card, badgeText) {
      var wrapper = card.querySelector('.grid-view-item-image');
      if (!wrapper) return;

      var badge = normalizeBadge(badgeText);

      // The theme handles preorder badges itself. Suppress all competing badge
      // types so the preorder badge remains the only visible status.
      if (isPreorderBadge(badge)) {
        hideAllBadges(wrapper);
        return;
      }

      if (isSoldOutBadge(badge)) {
        showSoldOutBadge(wrapper);
        return;
      }

      if (isLowStockBadge(badge)) {
        showTextBadge(wrapper, badge);
        return;
      }

      if (badge && !isNewBadge(badge) && !isSaleBadge(badge)) {
        showTextBadge(wrapper, badge);
        return;
      }

      // New outranks sale: a New value hides every percentage badge.
      if (isNewBadge(badge)) {
        showTextBadge(wrapper, badge);
        return;
      }

      // A percentage appears only when no higher-priority badge was supplied.
      if (isSaleBadge(badge)) {
        showSaleBadge(wrapper, badge);
        return;
      }

      hideAllBadges(wrapper);
    }

    function getActiveSwatch(card) {
      // Each combined-listing card owns its own active swatch and badge.
      return card.querySelector('.card-color-swatch--inner.active') ||
        card.querySelector('.card-color-swatch--inner');
    }

    function restoreBadge(card) {
      var activeSwatch = getActiveSwatch(card);
      if (!activeSwatch) return;

      setBadge(card, activeSwatch.dataset.colorBadge);
    }

    function scheduleBadgeRestore(card) {
      // The theme may update several active-swatch classes or attributes at
      // once. Render after that batch to avoid displaying a transient badge.
      if (card._badgeRestoreTimer) {
        window.clearTimeout(card._badgeRestoreTimer);
      }

      card._badgeRestoreTimer = window.setTimeout(function() {
        card._badgeRestoreTimer = null;
        restoreBadge(card);
      }, 0);
    }

    function initializeBadge(card) {
      restoreBadge(card);

      var renderAfterThemeSetup = function() {
        if (card.isConnected) scheduleBadgeRestore(card);
      };

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(function() {
          window.requestAnimationFrame(renderAfterThemeSetup);
        });
      } else {
        window.setTimeout(renderAfterThemeSetup, 0);
      }
    }

    function attachListeners(card) {
      if (card.getAttribute('data-badge-listeners-attached')) return;

      var swatches = card.querySelectorAll('.card-color-swatch--inner');
      if (!swatches.length) return;

      card.setAttribute('data-badge-listeners-attached', 'true');

      swatches.forEach(function(swatch) {
        swatch.addEventListener('mouseover', function() {
          setBadge(card, this.dataset.colorBadge);
        });

        swatch.addEventListener('mouseleave', function() {
          restoreBadge(card);
        });

        swatch.addEventListener('click', function() {
          setBadge(card, this.dataset.colorBadge);
          scheduleBadgeRestore(card);
        });
      });

      card.addEventListener('mouseleave', function() {
        restoreBadge(card);
      });

      initializeBadge(card);
    }

    document.querySelectorAll('product-card').forEach(attachListeners);

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes') {
          var attributeCard = mutation.target.closest &&
            mutation.target.closest('product-card');
          if (attributeCard) scheduleBadgeRestore(attributeCard);
          return;
        }

        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;

          // A product-card may be inserted before its image wrapper or swatches.
          // Re-check the containing card as its markup arrives.
          var parentCard = node.closest && node.closest('product-card');
          if (parentCard) {
            attachListeners(parentCard);
            scheduleBadgeRestore(parentCard);
          }

          if (node.tagName && node.tagName.toLowerCase() === 'product-card') {
            attachListeners(node);
            scheduleBadgeRestore(node);
          }

          if (node.querySelectorAll) {
            node.querySelectorAll('product-card').forEach(function(nestedCard) {
              attachListeners(nestedCard);
              scheduleBadgeRestore(nestedCard);
            });
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-color-badge']
    });
  }

  // Supports both normal theme loads and assets injected after DOMContentLoaded.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
